import React, { useContext, useMemo, useState } from 'react'
import styled from 'styled-components'
import { get } from 'lodash'
import Checkbox from '@shared/components/Checkbox'
import Input from '@shared/components/Input'
import { AppContext } from '../../Context'
import { checkSimulation } from '../../services'
import PageLayout from '../../components/PageLayout'
import { useNavigate } from 'react-router'
import { SimulationContext } from './SimulationPage'
import LabelField from '@shared/components/LabelField'
import { DecimalFormatter, NumberFormatter } from '@shared/utils/util'
import { Comment, Sector } from '@shared/components/Text'

const SimulationAllocationPageContainer = styled(PageLayout)`
  margin: 0 20px;
  & > .content > .field {
    margin-top: 20px;
  }
  & > .content > .checkbox {
    margin-top: 20px;
  }
  .second {
    padding-top: 20px;
    .field{
      margin-top:5px;
    }
  }
  .content {
    margin-bottom: 10px;
  }
`
function SimulationForm({ ...props }) {

  const navigate = useNavigate()

  const { employee, familySituations } = useContext(AppContext)
  const { simulation, setSimulation, parentHistory, simulationOnly } = useContext(SimulationContext)
  const [canSubmit, setCanSubmit] = useState(!simulationOnly)
  const [second, setSecond] = useState(false)

  const familySituationCode = useMemo(() => employee && get(employee, 'situationFamily'), [employee])

  const employeeFamilySituation = useMemo(() => familySituations && familySituationCode && familySituations[familySituationCode],
                                                  [familySituations, familySituationCode])

  const singleFamily = useMemo(() => employeeFamilySituation && employeeFamilySituation.isSingleParent, [employeeFamilySituation])

  const onValueChange = (key) => {
    return (value) => {
      const simu = {
        ...simulation,
        [key]: value
      }
      setSimulation(simu)
      if(simulationOnly && !simu.nbChildren) {
        setCanSubmit(false)
      } else if (second && !simu.partnerIncome) {
        setCanSubmit(false)
      } else {
        setCanSubmit(true)
      }
    }
  }

  const sendSimulation = () => {
    return checkSimulation(simulation, simulationOnly)
    .then(result => {
      if (get(result, 'data.benefitSimulation.eligible')) {
        navigate('success')
        return true
      } else if (!second && !singleFamily) {
        setSecond(true)
        setCanSubmit(false)
      } else {
        navigate('failed')
        return true
      }
    })
  }

  return (
    <SimulationAllocationPageContainer
      title="Simulation d’éligibilité"
      onPrevious={ () => parentHistory('/') }
      actions={ {
        submitTxt: 'Valider',
        onSubmit: sendSimulation,
        disableSubmit: !canSubmit
      } }
    >
      <Sector>Informations RH</Sector>
      <div className='field'>
        Le calcul de vos droits à l’allocation utilise vos données de rémunération internes RATP.
      </div>
      { !simulationOnly ?
        <LabelField label="Nombre d’enfants" subLabelUnderline={ true }> { get(employee, 'nbChildren') }</LabelField> :
        <Input label="Nombre d’enfant(s)"
               onValueChange={ onValueChange('nbChildren') }
               value={ simulation.nbChildren }
               formatter={ new NumberFormatter(1) }
               disabled={ second }
        />
      }

      { employeeFamilySituation && <LabelField label="Situation familiale" subLabelUnderline={ true }>{ employeeFamilySituation.label }</LabelField> }

      { singleFamily &&
      <Checkbox checked={ simulation.singleParent }
                onChange={ onValueChange('singleParent') }
                disabled={ simulation.isSecond }
      >Parent isolé</Checkbox> }
      <Input label="Pension alimentaire annuelle versée (€)*"
             value={ simulation.childSupport }
             onValueChange={ onValueChange('childSupport') }
             disabled={ second }
             formatter={ new DecimalFormatter() }
             description={'*données figurant sur votre avis d’imposition'}
      />
      {
        (second && !singleFamily) && <div className="second">
          <Comment>
            <div>Au regard de votre situation vous n’êtes pas éligible à l’allocation.</div>
            <div>Vous pouvez faire une autre simulation tenant compte des revenus de votre conjoint.e.</div>
          </Comment>
          <Input label="Revenu annuel de votre conjoint.e (€)*"
                 value={ simulation.partnerIncome }
                 onValueChange={ onValueChange('partnerIncome') }
                 formatter={ new DecimalFormatter() }
                 description={'*données figurant sur votre avis d’imposition'}
          />
        </div>
      }
    </SimulationAllocationPageContainer>
  )
}

export default SimulationForm
